import { useContext } from "react";
import { ShouldStoreToSeenContext, } from "./provider";
/** Full context (flag + setter) */
export const useShouldStoreToSeenContext = () => {
    const ctx = useContext(ShouldStoreToSeenContext);
    if (!ctx) {
        throw new Error("useShouldStoreToSeenContext must be used within a ShouldStoreToSeenProvider");
    }
    return ctx;
};
